import Button from '../ui/Button/Button';
import { useState, useEffect } from 'react';
import { usePageContext } from 'context/hooks/usePageContext';
import { useErrorContext } from 'context/hooks/useErrorContext';

type Metadata = {
  reference: string;
  message: string;
};

const ErrorComponent = () => {
  const { errorMessage } = usePageContext();
  const { error } = useErrorContext();
  const [errMsg, setErrMsg] = useState<string>('');

  const defaultMsg =
    'Sorry, your request could not be processed. An error occurred, try again.';

  useEffect(() => {
    if (error !== null && error.metadata) {
      const metadata: Metadata = error.metadata as Metadata;
      switch (metadata.message) {
        case 'Declined':
          setErrMsg('Card Declined');
          return;
        case 'Token Not Generated. Customer Not Registered on Token Platform':
          setErrMsg('Token Not Generated');
          return;
        case 'Insufficient funds':
          setErrMsg('Insufficient Funds');
          return;
        default:
          setErrMsg(defaultMsg);
      }
    }
  }, [error]);

  return (
    <div className="space-y-20 text-center py-10 flex flex-col items-center px-4 w-full">
      <div className="flex flex-col items-center gap-4 w-full">
        <img
          src="./icons/error.svg"
          alt="error Message"
          className="w-20"
        />
        <div className="w-full text-center bg-red-200 rounded-lg border-3 border-dashed border-red-600 px-6 py-3">
          <p className="text-red-600 text-base font-semibold">
            {errorMessage || errMsg || defaultMsg}
          </p>
        </div>
      </div>

      <div className="flex gap-3 w-full m-auto">
        <Button
          variant="outline"
          type="button"
          className="md:!text-lg"
          onClick={() =>
            window.parent.postMessage({ message: 'closeCeviantSDK' }, '*')
          }
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default ErrorComponent;
